export default "__VITE_ASSET__BA_sbZyv__"